export type HandoverPackSectionResponse = {
  handoverPackSectionId: number;
  sectionName: string;
  sectionSequence: string;
  documents: Array<DocumentResponse>;
};

export type PartResponse = {
  partNumber: string;
  partName: string;
};

export type DocumentResponse = {
  documentId: number;
  documentReference: string;
  documentName: string;
  customerName: string;
  documentUrl: string;
  documentVersion: number | null;
  handoverPackSectionId: number;
  handoverPackSectionSequence: string;
  isAlwaysIncluded: boolean;
  useNuHeatSuppliedHeatPump: boolean;
  useSolar: boolean;
  useUnderfloorHeating: boolean;
  useUserSuppliedHeatPump: boolean;
  useBoiler: boolean;
  useAnyTechnology: boolean;
  matchAllParts: boolean;
  parts: Array<PartResponse>;
  secondaryParts: Array<PartResponse>;
  includeInContentsPage: boolean;
  includeInPrintFolder: boolean;
  prePrinted: boolean;
  neverPrint: boolean;
};

export type GetHandoverPackSectionsResponse = {
  handoverPackSections: Array<HandoverPackSectionResponse>;
  parts: Array<PartResponse>;
};

export type GetHandoverPackSectionsByFilterResponse = {
  handoverPackSections: Array<HandoverPackSectionResponse>;
};

export const getHandoverPackSectionSelectOptions = (handoverPackSections: Array<HandoverPackSectionResponse>) =>
  handoverPackSections.map(section => ({
    value: section.handoverPackSectionId,
    text: `${section.sectionName} - ${section.sectionSequence}`,
  }));

export const getHandoverPackSectionMultiSelectOptions = (handoverPackSections: Array<HandoverPackSectionResponse>) =>
  handoverPackSections.map(section => ({
    value: section.handoverPackSectionId,
    label: `${section.sectionName} - ${section.sectionSequence}`,
  }));

export const getPartMultiSelectOptions = (parts: Array<PartResponse>) =>
  parts.map(part => ({
    value: part.partNumber,
    label: part.partName,
  }));
